export default {"src":"/_next/static/media/sony.2907c0db.svg","height":28,"width":156};